/**
 * 解决方案统一数据源
 * 根据 slug 动态匹配对应的解决方案内容
 */

// Tab 导航配置
export const solutionTabs = [
  { id: 'background', label: '方案概述' },
  { id: 'challenges', label: '业务挑战' },
  { id: 'capabilities', label: '核心能力' },
  { id: 'architecture', label: '方案架构' },
  { id: 'scenarios', label: '适用场景' },
  { id: 'faq', label: 'Q&A' }
]

// 解决方案分类
export const solutionCategories = {
  xinchuang: {
    name: '信创专题',
    color: '#2563eb',
    solutions: [
      'comprehensive-xinchuang',
      'private-cloud-security',
      'ai-platform'
    ]
  },
  cloudSecurity: {
    name: '云安全专题',
    color: '#059669',
    solutions: [
      'private-cloud-security',
      'industry-government-cloud-security',
      'large-institution-internet-egress-sslo',
      'carrier-dedicated-line-security',
      'sase-security-solution',
      'low-cost-security-for-small-and-medium-systems'
    ]
  },
  edgeInfrastructure: {
    name: '云基础设施专题',
    color: '#7c3aed',
    solutions: [
      'ai-infrastructure-solution',
      'edge-computing',
      'vm-container-fusion-infrastructure',
      'database-cloud-infrastructure',
      'compute-network-infrastructure'
    ]
  },
  aiApplication: {
    name: 'AI应用专题',
    color: '#dc2626',
    solutions: [
      'ai-threat-intel',
      'cloud-edge-model-collaboration',
      'edge-cv-security',
      'vehicle-ai-offense-defense-range'
    ]
  }
}

// 所有解决方案数据
export const solutionsData = {
  // ========== 信创专题 ==========
  'comprehensive-xinchuang': {
    title: '全面拥抱信创解决方案',
    category: 'xinchuang',
    description: '国产化生态适配与信创升级替代方案，全面支持鲲鹏、飞腾、龙芯等国产芯片架构',
    heroImage: null,
    background: '随着国家信创战略的深入推进，企业数字化转型面临国产化替代的紧迫需求。传统IT架构依赖国外核心技术，存在供应链安全风险和合规压力。瑞和云图全面拥抱信创生态，提供从硬件到软件的全栈国产化解决方案，支持鲲鹏、飞腾、海光、龙芯等国产CPU架构，适配银河麒麟、统信UOS等国产操作系统，助力企业实现安全可控的数字化转型。',
    challenges: [
      { title: '国产化生态适配复杂', desc: '国产芯片、操作系统、数据库等组件生态碎片化，兼容适配工作量大，技术门槛高。' },
      { title: '存量系统迁移风险', desc: '传统x86架构应用迁移至国产平台，存在性能差异、兼容性问题，迁移周期长、风险高。' },
      { title: '信创运维能力不足', desc: '国产化IT基础设施运维经验不足，缺乏统一管理平台，运维效率低、成本高。' },
      { title: '合规要求严格', desc: '党政军、金融等行业信创合规要求严格，需满足等保、密码等安全标准。' }
    ],
    capabilities: [
      { title: '全栈国产化适配', desc: '支持鲲鹏、飞腾、海光、龙芯等国产CPU，适配银河麒麟、统信UOS等国产操作系统' },
      { title: '异构资源统一纳管', desc: '统一管理x86与国产化异构资源，实现跨架构的资源调度与业务协同' },
      { title: '平滑迁移方案', desc: '提供应用迁移评估、兼容性测试、数据迁移等全流程服务，降低迁移风险' },
      { title: '信创安全合规', desc: '满足等保2.0、密码安全等国标要求，提供信创安全加固方案' }
    ],
    scenarios: [
      { title: '党政信创替代', desc: '为党政机关提供办公系统、业务系统信创替代方案，满足安全可控要求' },
      { title: '金融信创升级', desc: '为金融机构提供核心业务系统信创升级方案，保障业务连续性' },
      { title: '国企数字化转型', desc: '为国有企业提供信创数字化转型方案，实现安全可控的IT架构升级' }
    ],
    architecture: '瑞和信创解决方案采用"异构融合、统一管控"的架构设计。底层兼容鲲鹏、飞腾、海光、龙芯等多种国产CPU架构，中间层通过统一虚拟化平台实现异构资源的池化管理，上层提供信创应用迁移工具链和统一运维平台，实现从基础设施到应用层面的全栈国产化支撑。',
    faq: [
      { question: '信创迁移会影响现有业务运行吗？', answer: '我们提供平滑迁移方案，支持存量系统逐步迁移，新旧系统并行运行，最大程度降低对业务的影响。迁移前会进行充分的兼容性测试和性能评估。' },
      { question: '支持哪些国产化软硬件？', answer: '支持鲲鹏、飞腾、海光、龙芯等国产CPU，适配银河麒麟、统信UOS等国产操作系统，以及达梦、人大金仓等国产数据库。' },
      { question: '如何保障信创系统的安全性？', answer: '方案内置等保2.0合规模板，支持国密算法，提供安全加固服务，满足党政军、金融等行业的严格安全要求。' }
    ],
    relatedProducts: ['cloud-security-resource-pool', 'edge-cloud-platform', 'multi-cloud-management']
  },

  'private-cloud-security': {
    title: '私有云安全解决方案',
    category: 'cloudSecurity',
    description: '面向私有云的一体化安全能力供给与合规管控，集约交付防火墙、WAF、审计等能力',
    heroImage: null,
    background: '私有云已成为企业数字化转型的核心基础设施，但传统安全建设模式存在安全能力分散、资源利用率低、运维成本高等问题。瑞和云图私有云安全解决方案以安全资源池为核心，集约交付防火墙、WAF、入侵检测、日志审计等安全能力，实现安全能力的统一调度与弹性供给，降低建设与运维成本，满足等保与数据安全要求。',
    challenges: [
      { title: '安全能力分散建设', desc: '传统模式下各安全设备独立采购、独立部署，形成安全能力孤岛，无法统一调度。' },
      { title: '资源利用率低下', desc: '安全设备资源固化，无法弹性伸缩，忙闲不均导致资源浪费严重。' },
      { title: '运维成本高昂', desc: '多品牌、多类型安全设备运维复杂，需要专业安全运维团队，成本居高不下。' },
      { title: '合规压力巨大', desc: '等保2.0、数据安全法等法规要求严格，合规建设与审计工作量大。' }
    ],
    capabilities: [
      { title: '安全能力集约供给', desc: '以安全资源池为核心，集约交付防火墙、WAF、入侵检测、审计等安全能力' },
      { title: '流量智能编排', desc: '基于业务需求智能编排流量，实现安全能力的按需调用与负载均衡' },
      { title: '统一运维管控', desc: '统一管理平台实现安全设备的集中监控、策略下发、日志分析' },
      { title: '合规自动化', desc: '内置等保合规模板，自动化合规检查与报告生成，降低合规工作量' }
    ],
    scenarios: [
      { title: '政务云安全', desc: '为政务云平台提供一体化安全防护，满足等保三级要求' },
      { title: '金融云安全', desc: '为金融机构私有云提供安全能力供给，满足金融行业安全规范' },
      { title: '企业私有云安全', desc: '为企业私有云提供集约化安全建设方案，降低安全建设成本' }
    ],
    architecture: '私有云安全解决方案以安全资源池为核心，通过SSLO流量编排技术实现流量的智能调度。安全资源池集约交付防火墙、WAF、入侵检测、日志审计等安全能力，统一管控平台实现策略下发、设备监控、日志分析，形成"流量编排-能力供给-统一管控"的一体化架构。',
    faq: [
      { question: '安全资源池如何实现弹性供给？', answer: '安全资源池采用云原生架构，支持安全能力的弹性伸缩。根据业务流量和安全策略需求，动态调度安全资源，实现按需供给，提升资源利用率。' },
      { question: '是否支持多品牌安全设备？', answer: '是的，方案支持纳管主流安全厂商的防火墙、WAF等设备，实现多品牌设备的统一管控，保护客户既有投资。' },
      { question: '如何满足等保合规要求？', answer: '方案内置等保2.0合规模板，自动化进行合规检查、策略配置和报告生成，大幅降低合规工作量，确保持续合规。' }
    ],
    relatedProducts: ['cloud-security-resource-pool', 'sslo', 'next-gen-firewall']
  },

  'ai-platform': {
    title: 'AI 算力平台解决方案',
    category: 'xinchuang',
    description: '以 AI 算力平台为底座，组合算网大脑、边缘推理和安全资源，串成可演进的建设路径',
    heroImage: null,
    background: '人工智能技术飞速发展，企业AI应用需求激增。传统IT架构难以支撑AI业务的高算力、低时延需求，存在算力分散、扩展性弱、运维复杂等问题。瑞和云图AI智算基础设施解决方案，提供从算力调度、模型管理到推理部署的全栈能力，为企业AI业务规模化落地提供坚实基础。',
    challenges: [
      { title: '算力资源分散', desc: 'GPU等算力资源分散部署，无法统一调度，利用率低下。' },
      { title: '模型管理混乱', desc: 'AI模型版本管理不规范，缺乏统一的模型仓库与版本控制机制。' },
      { title: '推理部署复杂', desc: '模型推理部署流程繁琐，缺乏自动化部署与弹性伸缩能力。' },
      { title: '运维门槛高', desc: 'AI基础设施运维需要专业AI运维知识，人才稀缺、成本高。' }
    ],
    capabilities: [
      { title: '异构算力统一调度', desc: '统一纳管GPU、NPU等异构算力，实现智能调度与负载均衡' },
      { title: '模型全生命周期管理', desc: '提供模型训练、版本管理、部署发布、监控运维全流程能力' },
      { title: '推理服务弹性部署', desc: '支持模型推理服务的快速部署、弹性伸缩与灰度发布' },
      { title: 'AI运维自动化', desc: '提供AI基础设施的自动化运维能力，降低运维门槛' }
    ],
    scenarios: [
      { title: '大模型训练', desc: '支撑大语言模型、多模态模型的分布式训练需求' },
      { title: 'AI推理服务', desc: '为AI应用提供高性能、高可用的推理服务支撑' },
      { title: 'AI开发平台', desc: '为企业提供AI模型开发、测试、部署一体化平台' }
    ],
    architecture: 'AI智算基础设施采用"算力调度-模型管理-推理部署"三层架构。底层统一纳管GPU、NPU等异构算力资源，中间层提供模型训练、版本管理、部署发布等全生命周期管理能力，上层支撑AI推理服务的快速部署和弹性伸缩，为企业AI业务提供端到端支撑。',
    faq: [
      { question: '支持哪些类型的算力资源？', answer: '支持NVIDIA GPU、华为昇腾NPU、寒武纪MLU等主流AI芯片，实现异构算力的统一调度和负载均衡。' },
      { question: '如何保障模型训练的效率？', answer: '平台提供分布式训练框架、自动并行策略优化、训练任务调度等能力，大幅提升模型训练效率，缩短研发周期。' },
      { question: '推理服务如何实现弹性伸缩？', answer: '支持基于流量、延迟等指标自动扩缩容，配合灰度发布、A/B测试等能力，实现推理服务的高可用和弹性交付。' }
    ],
    relatedProducts: ['ai-computing', 'hyper-converged-cloud', 'intelligent-traffic-screening']
  },

  // ========== 云安全专题 ==========
  'industry-government-cloud-security': {
    title: '行业云/政务云安全解决方案',
    category: 'cloudSecurity',
    description: '面向行业云和政务云的一体化安全防护与合规管控方案',
    heroImage: null,
    background: '行业云、政务云作为重要的数字化转型基础设施，承载着大量敏感数据和关键业务系统。传统安全建设模式难以满足多租户隔离、合规审计、统一管控等需求。瑞和云图行业云/政务云安全解决方案，以安全资源池为核心，提供多租户安全隔离、统一安全管控、合规自动化等能力，助力行业云、政务云安全合规运营。',
    challenges: [
      { title: '多租户安全隔离', desc: '行业云/政务云多租户场景下，需保障租户间的安全隔离与数据安全。' },
      { title: '合规要求严格', desc: '政务云需满足等保2.0三级、密码安全等国标要求，合规压力大。' },
      { title: '统一管控困难', desc: '多部门、多业务系统安全策略分散，缺乏统一管控平台。' },
      { title: '安全运营复杂', desc: '安全事件响应、日志分析、策略调整等运营工作量大。' }
    ],
    capabilities: [
      { title: '多租户安全隔离', desc: '提供租户间网络、资源、数据的逻辑隔离，保障租户安全' },
      { title: '统一安全管控', desc: '统一平台实现安全策略下发、设备监控、日志分析' },
      { title: '合规自动化', desc: '内置政务云合规模板，自动化合规检查与报告生成' },
      { title: '安全运营支撑', desc: '提供安全事件响应、威胁分析、策略优化等运营能力' }
    ],
    scenarios: [
      { title: '政务云安全', desc: '为省级、市级政务云平台提供安全防护与合规保障' },
      { title: '行业云安全', desc: '为金融、医疗、教育等行业云提供安全解决方案' },
      { title: '多云安全管控', desc: '为多云环境提供统一安全管控平台' }
    ],
    architecture: '行业云/政务云安全解决方案采用"多租户隔离-统一管控-合规自动化"架构。通过安全资源池实现租户间安全能力的逻辑隔离，统一管控平台实现多租户安全策略的集中管理，内置合规模板自动化满足等保、密码安全等国标要求。',
    faq: [
      { question: '如何实现多租户安全隔离？', answer: '通过安全资源池的虚拟化技术，为每个租户分配独立的安全能力实例，实现网络、资源、数据的逻辑隔离，保障租户安全。' },
      { question: '支持哪些合规标准？', answer: '支持等保2.0三级、密码安全、数据安全法等主流合规标准，内置合规模板和自动化检查能力。' },
      { question: '如何降低安全运营成本？', answer: '统一管控平台实现安全设备的集中监控、策略统一下发、日志集中分析，大幅降低多租户安全运营的工作量和成本。' }
    ],
    relatedProducts: ['cloud-security-resource-pool', 'next-gen-firewall', 'web-application-firewall']
  },

  'carrier-dedicated-line-security': {
    title: '运营商安全解决方案',
    category: 'cloudSecurity',
    description: '为专线场景提供安全检测、防护等增值能力，助力运营商提升专线业务价值',
    heroImage: null,
    background: '专线业务是运营商重要的企业服务产品，但传统专线仅提供网络连接能力，缺乏安全增值服务。随着企业安全需求增长，运营商亟需为专线业务叠加安全能力，提升产品价值与用户粘性。瑞和云图运营商安全解决方案，为运营商提供专线安全增值服务能力，助力运营商拓展安全业务收入。',
    challenges: [
      { title: '专线价值单一', desc: '传统专线仅提供网络连接，缺乏安全增值服务，产品竞争力不足。' },
      { title: '安全能力叠加难', desc: '专线网络架构固定，安全能力叠加部署复杂，影响专线性能。' },
      { title: '多租户运营复杂', desc: '运营商需为大量企业客户提供专线安全服务，运营管理复杂。' },
      { title: '安全服务定价难', desc: '安全增值服务定价模式不清晰，影响业务推广。' }
    ],
    capabilities: [
      { title: '专线安全能力叠加', desc: '为专线叠加入侵检测、流量分析、安全审计等安全能力' },
      { title: '透明部署模式', desc: '支持透明部署，不影响专线网络架构与业务性能' },
      { title: '多租户运营平台', desc: '提供专线安全服务的多租户运营管理平台' },
      { title: '灵活计费模式', desc: '支持按流量、按事件、按时间等多种计费模式' }
    ],
    scenarios: [
      { title: '运营商专线安全', desc: '为运营商政企专线提供安全增值服务' },
      { title: 'MPLS专线安全', desc: '为MPLS专线提供安全检测与防护能力' },
      { title: 'SD-WAN安全', desc: '为SD-WAN组网提供安全能力叠加' }
    ],
    architecture: '运营商安全解决方案采用"透明叠加-增值运营"架构。安全能力以透明模式叠加在专线网络中，不影响原有网络架构和业务性能。多租户运营平台支持专线安全服务的灵活计费和自助管理，助力运营商拓展安全业务收入。',
    faq: [
      { question: '安全能力叠加是否影响专线性能？', answer: '采用透明部署模式，支持旁路检测和串接防护两种模式，可根据客户需求灵活选择，最小化对专线性能的影响。' },
      { question: '支持哪些计费模式？', answer: '支持按流量、按事件、按时间、按用户数等多种计费模式，运营商可根据市场需求灵活定价。' },
      { question: '如何管理大量企业客户？', answer: '提供多租户运营管理平台，支持企业客户自助服务、服务开通、用量统计、账单管理等功能，降低运营成本。' }
    ],
    relatedProducts: ['cloud-security-resource-pool', 'sslo', 'intelligent-traffic-screening']
  },

  'sase-security-solution': {
    title: 'SASE安全解决方案',
    category: 'cloudSecurity',
    description: '融合网络与零信任安全能力，以统一安全访问服务边缘保障任意地点安全接入',
    heroImage: null,
    background: '随着企业数字化转型与远程办公普及，传统基于边界的网络安全架构难以适应分布式办公场景。SASE（安全访问服务边缘）架构融合网络与安全能力，以零信任理念重构安全架构，为任意地点、任意终端提供统一的安全接入与防护能力。瑞和云图SASE解决方案，帮助企业构建云原生安全架构，简化分支与移动办公安全。',
    challenges: [
      { title: '边界安全失效', desc: '传统边界安全架构无法适应分布式办公、移动办公场景。' },
      { title: '分支安全复杂', desc: '企业分支众多，安全设备分散部署，运维管理复杂。' },
      { title: '远程办公风险', desc: '远程办公接入企业资源，存在终端安全、数据泄露风险。' },
      { title: '安全能力割裂', desc: '网络安全、终端安全、应用安全能力割裂，缺乏统一管控。' }
    ],
    capabilities: [
      { title: '零信任接入', desc: '基于零信任理念，对任意接入请求进行身份验证与权限控制' },
      { title: '统一安全边缘', desc: '融合网络与安全能力，提供统一的安全访问服务边缘' },
      { title: '云原生架构', desc: '基于云原生架构，支持弹性伸缩与按需服务' },
      { title: '全场景覆盖', desc: '覆盖分支、移动办公、第三方接入等全场景' }
    ],
    scenarios: [
      { title: '企业分支安全', desc: '为企业分支提供统一安全接入与防护能力' },
      { title: '远程办公安全', desc: '为远程办公提供安全接入与数据保护' },
      { title: '零信任架构', desc: '帮助企业构建零信任安全架构' }
    ],
    architecture: 'SASE解决方案融合网络与安全能力，构建"零信任接入-统一边缘-云原生服务"架构。基于零信任理念，对所有接入请求进行身份验证和权限控制，通过统一的安全访问服务边缘（SASE）提供网络连接和安全防护，云原生架构支持弹性伸缩和按需服务。',
    faq: [
      { question: 'SASE与传统VPN有何区别？', answer: 'SASE基于零信任理念，不依赖网络位置信任，对所有访问请求进行身份验证和权限控制。相比VPN，SASE提供更细粒度的访问控制和更丰富的安全能力。' },
      { question: '如何保障远程办公安全？', answer: '通过终端安全检测、身份认证、访问控制、数据防泄露等多层防护，保障远程办公场景下的企业数据安全。' },
      { question: '是否支持混合云环境？', answer: '是的，SASE架构支持公有云、私有云、混合云等多种环境，实现统一的安全接入和防护能力。' }
    ],
    relatedProducts: ['sslo', 'next-gen-firewall', 'web-application-firewall']
  },

  'low-cost-security-for-small-and-medium-systems': {
    title: '中小系统低成本安全解决方案',
    category: 'cloudSecurity',
    description: '面向中小型业务系统的低成本安全建设方案，降低安全建设门槛',
    heroImage: null,
    background: '中小型企业和业务系统面临安全建设成本高、专业安全人员缺乏的困境。传统安全建设需要采购多种安全设备、组建安全运维团队，投入巨大。瑞和云图中小系统低成本安全解决方案，以一体化安全设备为核心，集约交付多种安全能力，大幅降低安全建设成本与运维门槛，让中小企业也能享受专业安全防护。',
    challenges: [
      { title: '安全预算有限', desc: '中小企业安全预算有限，难以承担传统安全建设的高昂成本。' },
      { title: '专业人才缺乏', desc: '中小企业缺乏专业安全运维人员，安全运维能力不足。' },
      { title: '合规压力', desc: '中小企业同样面临等保合规要求，合规建设压力大。' },
      { title: '安全能力不足', desc: '中小企业安全防护能力薄弱，易成为攻击目标。' }
    ],
    capabilities: [
      { title: '一体化安全设备', desc: '一台设备集成防火墙、WAF、审计等多种安全能力' },
      { title: '开箱即用', desc: '预配置安全策略，开箱即用，降低部署门槛' },
      { title: '自动化运维', desc: '自动化安全策略更新、日志分析、告警响应' },
      { title: '低成本合规', desc: '内置等保合规模板，低成本满足合规要求' }
    ],
    scenarios: [
      { title: '中小企业安全', desc: '为中小企业提供低成本安全建设方案' },
      { title: '中小系统防护', desc: '为中小型业务系统提供一体化安全防护' },
      { title: '等保合规建设', desc: '帮助中小企业低成本满足等保合规要求' }
    ],
    architecture: '中小系统低成本安全解决方案采用"一体化安全设备-开箱即用"架构。单台设备集成防火墙、WAF、入侵检测、日志审计等多种安全能力，预配置安全策略，支持快速部署。内置等保合规模板，自动化完成合规检查和报告生成。',
    faq: [
      { question: '一台设备能满足等保三级要求吗？', answer: '是的，一体化安全设备内置等保三级所需的安全能力，配合自动化合规检查和报告生成，可满足中小企业等保合规需求。' },
      { question: '部署复杂吗？需要专业人员吗？', answer: '设备预配置安全策略，支持图形化管理界面，开箱即用。中小企业无需专业安全人员即可完成日常运维。' },
      { question: '后续如何更新安全策略？', answer: '设备支持云端策略自动更新，实时获取最新威胁情报和安全策略，无需人工干预。' }
    ],
    relatedProducts: ['equal-protection-appliance', 'next-gen-firewall', 'host-security-management']
  },

  'large-institution-internet-egress-sslo': {
    title: '互联网出口安全解决方案',
    category: 'cloudSecurity',
    description: '基于SSLO安全流量编排的互联网出口流量编排与安全资源池方案',
    heroImage: null,
    background: '大型机构互联网出口承载着大量业务流量，面临流量复杂、安全威胁多、合规要求严等挑战。传统互联网出口安全建设存在安全设备串联部署性能瓶颈、流量编排困难、运维复杂等问题。瑞和云图互联网出口安全解决方案，基于SSLO流量编排技术，实现流量的智能调度与安全能力的弹性供给，构建高性能、高安全的互联网出口。',
    challenges: [
      { title: '流量复杂多样', desc: '互联网出口流量类型复杂，包含业务流量、办公流量、外部访问等。' },
      { title: '安全设备性能瓶颈', desc: '安全设备串联部署，性能瓶颈影响业务访问体验。' },
      { title: '流量编排困难', desc: '不同流量需经过不同安全设备，流量编排策略复杂。' },
      { title: '合规审计压力大', desc: '互联网出口需满足上网行为审计、数据防泄露等合规要求。' }
    ],
    capabilities: [
      { title: '智能流量编排', desc: '基于SSLO技术实现流量的智能识别与编排调度' },
      { title: '安全能力弹性供给', desc: '安全资源池实现安全能力的弹性调用与负载均衡' },
      { title: '高性能架构', desc: '流量编排避免设备串联性能瓶颈，保障访问体验' },
      { title: '合规审计能力', desc: '内置上网行为审计、数据防泄露等合规能力' }
    ],
    scenarios: [
      { title: '政务机构互联网出口', desc: '为政务机构提供安全合规的互联网出口方案' },
      { title: '金融机构互联网出口', desc: '为金融机构提供高性能互联网出口安全方案' },
      { title: '大型企业互联网出口', desc: '为大型企业提供流量编排与安全防护方案' }
    ],
    architecture: '互联网出口安全解决方案基于SSLO流量编排技术，构建"智能编排-弹性供给-合规审计"架构。通过流量智能识别实现流量的分类编排，安全资源池弹性供给防火墙、WAF等安全能力，内置上网行为审计、数据防泄露等合规能力。',
    faq: [
      { question: 'SSLO流量编排有什么优势？', answer: 'SSLO可根据业务需求智能识别和编排流量，将不同类型流量导向相应安全设备，避免设备串联部署的性能瓶颈，提升访问体验。' },
      { question: '如何保障高并发场景的性能？', answer: '采用分布式架构和负载均衡技术，支持水平扩展，单点性能不足时可弹性增加安全资源，保障高并发场景的访问体验。' },
      { question: '如何满足上网行为审计要求？', answer: '内置上网行为审计模块，自动记录用户访问行为，生成合规报告，满足相关法规要求。' }
    ],
    relatedProducts: ['sslo', 'cloud-security-resource-pool', 'web-application-firewall']
  },

  // ========== 云基础设施专题 ==========
  'ai-infrastructure-solution': {
    title: 'AI基础设施解决方案',
    category: 'edgeInfrastructure',
    description: '统一纳管异构算力与模型运行环境，支撑推理部署、弹性扩缩与运维管控',
    heroImage: null,
    background: '人工智能技术飞速发展与产业数字化深化，各类AI应用广泛落地，行业算力需求大幅提升。传统IT架构存在算力分散、扩展性弱等短板，难以匹配AI高算力、低时延的运行要求。瑞和云图AI基础设施解决方案，统一纳管异构算力与模型运行环境，支撑推理部署、弹性扩缩与运维管控，为企业AI业务规模化落地提供稳定、高效的算力与平台底座。',
    challenges: [
      { title: '平台架构融合不足', desc: 'AI业务平台与企业传统基础设施相互独立、架构割裂，无法形成统一承载体系。' },
      { title: '模型管理体系零散', desc: '各类算法模型缺乏集中化、标准化的管控平台，版本混乱、权限分散。' },
      { title: '推理服务承载薄弱', desc: '推理服务分散部署、独立运行，缺乏统一的发布、运维与负载管理体系。' },
      { title: '算力资源调度低效', desc: '算力资源分散部署，无法根据业务负载按需分配，利用率低。' }
    ],
    capabilities: [
      { title: '多场景灵活部署', desc: '支持从边缘部署到数据中心部署的多样化场景需求' },
      { title: '完整生产级基础设施', desc: 'AI平台与云平台深度融合，构建高可用、智能化的AI生产环境' },
      { title: '覆盖多样AI业务需求', desc: '支撑从内部提效到业务赋能的各类AI应用场景' },
      { title: '弹性算力调度', desc: '内置智能算力调度引擎，动态调度异构算力，提升利用率' }
    ],
    scenarios: [
      { title: '大模型训练与迭代', desc: '支撑大模型研发，提供高性能算力、分布式存储及高速网络' },
      { title: 'AI推理服务规模化部署', desc: '搭建统一推理服务平台，实现模型集中管理与快速部署' },
      { title: '企业级AI一体化运维', desc: '整合模型管理、算力调度、运维监控能力，实现全生命周期运维' }
    ],
    architecture: 'AI基础设施解决方案采用"算力调度-平台融合-业务赋能"三层架构。底层统一纳管GPU、NPU等异构算力资源，中间层提供AI平台与云平台深度融合的基础设施，上层支撑大模型训练、推理服务部署、AI应用开发等多场景需求。',
    faq: [
      { question: '支持哪些AI芯片？', answer: '支持NVIDIA GPU、华为昇腾NPU、寒武纪MLU、海光DCU等主流AI芯片，实现异构算力的统一管理和调度。' },
      { question: '如何保障AI业务的高可用？', answer: '平台提供算力资源池化、任务自动迁移、故障自动恢复等能力，保障AI业务持续稳定运行。' },
      { question: '是否支持边缘部署？', answer: '是的，支持从边缘到数据中心的全场景部署，满足低时延、数据本地化等需求。' }
    ],
    relatedProducts: ['ai-computing', 'hyper-converged-cloud', 'edge-cloud-platform']
  },

  'server-virtualization': {
    title: '服务器虚拟化解决方案',
    category: 'edgeInfrastructure',
    description: '异构资源统一纳管与虚拟化资源池化，降低建设与运维成本',
    heroImage: null,
    background: '随着企业数字化转型深入推进，业务系统数量持续增长，传统物理服务器单机部署模式资源利用率低下、业务交付周期长、运维成本高。瑞和云图服务器虚拟化解决方案，依托云计算管理平台，通过虚拟化技术将底层物理硬件资源抽象为弹性可调度的虚拟资源，实现资源池化、管理统一化，帮助企业盘活存量IT资产，降本增效。',
    challenges: [
      { title: '资源利用率低下', desc: '传统单机部署模式下，业务独占物理服务器，资源忙闲不均，利用率不足20%。' },
      { title: '业务交付效率低', desc: '新业务上线需经历硬件采购、上架、系统配置等全流程，周期长达2-3周。' },
      { title: '异构资源管理割裂', desc: 'x86、国产化两类硬件架构及多种虚拟化技术独立运维，管理工具割裂。' },
      { title: '业务可靠性保障弱', desc: '单机部署模式下，服务器故障直接导致业务中断，缺乏高可用保障。' }
    ],
    capabilities: [
      { title: '异构资源全面兼容', desc: '原生支持x86与飞腾、海光等国产化架构，兼容多种虚拟化技术' },
      { title: '资源利用率大幅提升', desc: '通过资源池化与智能调度，将服务器利用率提升至60%以上' },
      { title: '业务交付效率提升', desc: '支持虚拟机模板化快速部署，新业务上线周期缩短至分钟级' },
      { title: '高可靠保障', desc: '提供热迁移、HA高可用、快照备份等能力，系统可用性达99.95%' }
    ],
    scenarios: [
      { title: '传统业务虚拟化迁移', desc: '支撑ERP、OA、CRM等传统业务系统平滑迁移至虚拟化平台' },
      { title: '多租户资源承载', desc: '为运营商提供多租户隔离的虚拟资源服务' },
      { title: '异构资源统一纳管', desc: '整合x86、国产化服务器及不同虚拟化技术的资源' }
    ],
    architecture: '服务器虚拟化解决方案采用"异构兼容-资源池化-统一管控"架构。通过虚拟化技术将底层物理硬件资源抽象为弹性可调度的虚拟资源池，支持x86与国产化架构的混合部署，统一管控平台实现资源的集中管理和智能调度。',
    faq: [
      { question: '资源利用率能提升多少？', answer: '通过资源池化和智能调度，可将服务器利用率从传统模式的20%提升至60%以上，大幅降低硬件采购成本。' },
      { question: '业务迁移会影响运行吗？', answer: '支持虚拟机模板化快速部署和热迁移技术，新业务上线周期缩短至分钟级，迁移过程对业务无感知。' },
      { question: '如何保障业务可靠性？', answer: '提供HA高可用、热迁移、快照备份等能力，系统可用性达99.95%，保障业务连续运行。' }
    ],
    relatedProducts: ['edge-cloud-platform', 'multi-cloud-management', 'equal-protection-appliance']
  },

  'edge-computing': {
    title: '边缘计算解决方案',
    category: 'edgeInfrastructure',
    description: '构建云-边-端一体化架构，将核心能力下沉至边缘，适配多行业边缘智能化落地',
    heroImage: null,
    background: '随着5G、物联网等技术融合，各行业边缘场景产生海量数据，对数据处理的实时性、低时延、安全性需求提升。瑞和云图边缘计算解决方案，构建云-边-端一体化架构，将核心能力下沉至边缘，联动云端实现全局管控，适配电力、工业、运营商、政务等多行业边缘智能化落地需求。',
    challenges: [
      { title: '低时延与高可靠难以兼顾', desc: '边缘场景对数据处理时延要求达到毫秒级，同时需保障业务连续运行。' },
      { title: '边缘资源管控难度大', desc: '边缘节点分布分散、数量众多，异构硬件资源配置参差不齐。' },
      { title: '云边协同能力不足', desc: '边缘节点与中心平台数据同步不及时，模型下发、策略更新滞后。' },
      { title: '部署与运维成本高', desc: '边缘节点部署环境复杂，故障排查难度大，运维成本高。' }
    ],
    capabilities: [
      { title: '云边协同高效', desc: '实现边缘数据就地处理，核心业务时延降低至毫秒级' },
      { title: '异构资源兼容', desc: '原生支持x86、鲲鹏、海光、飞腾等多种异构硬件架构' },
      { title: '统一管控运维', desc: '实现所有边缘节点、资源、业务的集中管控与可视化监控' },
      { title: '场景适配性强', desc: '可灵活适配电力、工业、运营商、政务等多行业边缘场景' }
    ],
    scenarios: [
      { title: '电力配网智能运维', desc: '实现设备温度实时采集、故障智能预警、数据就地分析' },
      { title: '工业智能制造', desc: '实时采集生产数据、设备运行参数，实现生产过程实时监控' },
      { title: '智慧政务/园区', desc: '实现人员流动监测、环境参数采集、安全隐患排查等功能' }
    ],
    architecture: '边缘计算解决方案采用"云-边-端一体化"架构。边缘节点承担本地数据处理和实时响应任务，核心能力下沉至边缘降低时延；云端平台实现全局管控、模型训练、策略下发；终端设备负责数据采集和轻量级推理。三层协同，实现毫秒级响应和全局管控。',
    faq: [
      { question: '边缘节点如何与云端协同？', answer: '通过云边协同机制，边缘节点实时上报状态和数据摘要，云端下发策略和模型更新，实现分钟级同步。' },
      { question: '边缘节点故障如何处理？', answer: '边缘节点支持本地自治，网络中断时可独立运行；云端实时监控边缘状态，故障节点自动告警和远程运维。' },
      { question: '支持哪些边缘硬件？', answer: '支持x86、ARM、国产化等多种边缘硬件架构，可根据场景需求灵活选择。' }
    ],
    relatedProducts: ['edge-cloud-platform', 'ai-computing', 'intelligent-traffic-screening']
  },

  'vm-container-fusion-infrastructure': {
    title: '超融合解决方案',
    category: 'edgeInfrastructure',
    description: '统一承载虚拟机与容器混合工作负载的融合方案，简化管理、降低成本',
    heroImage: null,
    background: '数字经济快速发展背景下，云原生、AI技术广泛应用，企业IT架构需同时承载虚拟机（稳态业务）与容器（敏态创新应用）双轨运行。传统IT基础设施中各组件分散部署，形成资源孤岛。瑞和云图超融合解决方案（VCCI），在单一系统中集成全栈组件，实现统一管控、网络互通，为AI应用提供支撑。',
    challenges: [
      { title: '基础设施管理割裂', desc: '虚拟机与容器环境独立，管理平台与技术栈不同，运维成本高。' },
      { title: '虚拟机与容器网络隔离', desc: '两者网络体系独立，缺乏互联互通机制，业务通信不畅。' },
      { title: '资源调度低效', desc: '资源调度独立、交付繁琐，无法满足AI应用快速部署需求。' },
      { title: '混合工作负载适配不足', desc: '传统架构无法深度融合两种环境，阻碍业务迭代。' }
    ],
    capabilities: [
      { title: '简化管理', desc: '一套架构实现基础设施的统一管理，简单易用，运维门槛低' },
      { title: '提升效率', desc: '平台上线快，Kubernetes集群交付速度快，应用快速迭代' },
      { title: '强大可靠', desc: '平台稳定可靠、性能卓越，提升应用可靠性' },
      { title: '节省成本', desc: '最小三个节点即可构建整个平台，基础设施统一管理' }
    ],
    scenarios: [
      { title: 'AI应用全生命周期部署', desc: '快速交付资源、调度算力，满足AI应用数据存储需求' },
      { title: '企业混合工作负载承载', desc: '支撑legacy系统与新兴容器化业务并存' },
      { title: '企业级IT基础设施集约化管理', desc: '整合多组件实现集约化部署，简化管理' }
    ],
    architecture: '虚拟化容器融合基础设施（VCCI）采用"统一架构-网络互通-混合调度"设计。单一系统中集成虚拟化和容器全栈组件，实现虚拟机与容器的统一管控和网络互通，支持混合工作负载的智能调度，简化管理、降低成本。',
    faq: [
      { question: '虚拟机和容器如何互通？', answer: '通过统一的网络平面，虚拟机和容器共享同一网络命名空间，实现网络互通和服务发现，无需复杂配置。' },
      { question: '最小部署规模是多少？', answer: '最小三个节点即可构建整个平台，支持从小规模起步、按需扩展，降低初始投入。' },
      { question: '适合哪些业务场景？', answer: '适合需要同时承载传统业务（虚拟机）和云原生应用（容器）的企业，特别是AI应用开发部署场景。' }
    ],
    relatedProducts: ['edge-cloud-platform', 'ai-computing', 'multi-cloud-management']
  },

  'database-cloud-infrastructure': {
    title: 'Paas服务解决方案',
    category: 'edgeInfrastructure',
    description: '多数据库统一管控与高可用云化基础设施方案',
    heroImage: null,
    background: '数据库作为企业IT应用的核心，在企业数据中心架构的云化转型中至关重要。当前用户部署数据库主要采用传统集成架构、虚拟化部署模式和数据库一体机等方式，无法兼顾高性能、稳定性、易管理性、敏捷性等需求。瑞和云图Paas服务解决方案，提供多数据库统一管控与高可用云化能力。',
    challenges: [
      { title: '数据库一体机成本高', desc: '数据库一体机成本高，运维复杂，弹性差，无法支持多数据库。' },
      { title: '物理服务器方案局限', desc: '物理服务器加集中式存储的方案，在成本、易维护性方面较差。' },
      { title: '虚拟化方案性能差距', desc: 'VMware加集中存储方案，性能与延迟与裸金属方案仍有差距。' },
      { title: '多数据库管理复杂', desc: 'Oracle、MySQL、SQL Server等多数据库管理复杂。' }
    ],
    capabilities: [
      { title: '极致性能', desc: '从虚拟化、接入层、缓存层到存储网络端到端性能优化' },
      { title: '可靠可控', desc: '核心基于自主研发的分布式块存储，可靠性经过金融生产环境检验' },
      { title: '多场景适配', desc: '覆盖核心数据库、主流业务数据库到云原生数据库多种场景' },
      { title: '生态适配', desc: '提供广泛的产品适配、性能优化，以及数据库云化管理集成' }
    ],
    scenarios: [
      { title: '多类型数据库统一管控', desc: '实现各类数据库的云端统一部署、监控与管理' },
      { title: 'AI及高并发业务支撑', desc: '通过云端弹性资源调度，满足数据库高算力、高IO需求' },
      { title: '混合数据库架构协同', desc: '实现云端与本地数据实时同步、互联互通' }
    ],
    architecture: '数据库云化基础设施采用"性能优化-可靠可控-多场景适配"架构。从虚拟化、接入层、缓存层到存储网络实现端到端性能优化，核心基于自主研发的分布式块存储保障可靠性，支持Oracle、MySQL、SQL Server等多类型数据库统一管控。',
    faq: [
      { question: '性能与物理机相比如何？', answer: '通过端到端性能优化，数据库云化方案性能接近物理机水平，同时具备弹性扩展和高可用能力。' },
      { question: '支持哪些数据库类型？', answer: '支持Oracle、MySQL、SQL Server、PostgreSQL等主流数据库，以及国产数据库如达梦、人大金仓等。' },
      { question: '如何保障数据可靠性？', answer: '核心存储基于自主研发的分布式块存储，可靠性经过金融生产环境验证，提供多副本、快照备份等保障机制。' }
    ],
    relatedProducts: ['edge-cloud-platform', 'database-audit', 'multi-cloud-management']
  },

  'compute-network-infrastructure': {
    title: '算力网络解决方案',
    category: 'edgeInfrastructure',
    description: '全域算力与网络资源一体化编排调度方案，支撑算力统一调度与业务协同',
    heroImage: null,
    background: '随着人工智能、大数据及各类新型数字化业务快速发展，全社会算力需求持续激增，异构算力资源分散孤立、跨域调度困难、资源利用率偏低等问题日益突出。瑞和云图算力网络解决方案，打通全域算力与网络资源，实现算力统一编排、灵活调度与高效协同，全面支撑企业数字化转型与AI业务规模化落地。',
    challenges: [
      { title: '算力资源碎片化', desc: '各类算力分散部署，异构资源无法互通共享，算力孤岛现象严重。' },
      { title: '跨域调度能力不足', desc: '跨区域、跨机房算力调度链路不通，网络时延高。' },
      { title: '业务承载压力攀升', desc: 'AI推理、大数据分析等业务对基础设施弹性扩展要求更高。' },
      { title: '运维管理复杂', desc: '分散算力、网络、存储多套体系独立管理，运维成本高。' }
    ],
    capabilities: [
      { title: '算网深度融合', desc: '以算力为核心、网络为根基，融合网云数智安边端能力' },
      { title: '算力全域泛在', desc: '构建算网共生体系，实现全域算力随时随地灵活覆盖' },
      { title: '全域智能编排', desc: '依托智能调度编排能力，动态适配业务负载' },
      { title: '算力服务化', desc: '将算力转化为公共基础服务，实现按需供给、弹性复用' }
    ],
    scenarios: [
      { title: 'AI算力协同调度', desc: '实现中心智算、边缘算力统一调度，按需分配异构算力' },
      { title: '算力跨域协同', desc: '支撑算力资源协同联动，优化全域算力资源布局' },
      { title: '行业数字化算力承载', desc: '为政务、医疗、工业制造等行业提供算网支撑' }
    ],
    architecture: '算力网络基础设施采用"算网融合-全域泛在-智能编排"架构。以算力为核心、网络为根基，融合网云数智安边端能力，构建算网共生体系。通过智能调度编排引擎，实现全域算力随时随地灵活覆盖和按需供给。',
    faq: [
      { question: '如何实现跨域算力调度？', answer: '通过统一的算力编排平台，实现跨区域、跨机房算力资源的智能调度，优化网络路径，降低时延。' },
      { question: '支持哪些类型的算力？', answer: '支持CPU通用算力、GPU/NPU智算算力、边缘算力等多种类型，实现异构算力的统一管理和调度。' },
      { question: '算力如何服务化？', answer: '将算力资源转化为公共基础服务，通过标准化API提供算力服务，实现按需申请、弹性使用、灵活计费。' }
    ],
    relatedProducts: ['multi-cloud-management', 'ai-computing', 'edge-cloud-platform']
  },

  // ========== AI应用专题 ==========
  'ai-threat-intel': {
    title: 'AI加持威胁情报解决方案',
    category: 'aiApplication',
    description: 'AI与威胁情报深度融合的主动防御方案，提升安全运营与响应效率',
    heroImage: null,
    background: '随着数字化转型深入，网络攻击呈现智能化、隐蔽化、规模化趋势，勒索病毒、APT攻击、零日漏洞利用等新型威胁持续爆发。传统威胁情报依赖人工分析，处理效率低下。瑞和云图AI加持威胁情报解决方案，将AI技术与威胁情报深度融合，构建智能化、主动化的安全防御体系。',
    challenges: [
      { title: '威胁情报处理效率低', desc: '海量威胁情报实时涌入，人工分析无法快速筛选、关联、研判。' },
      { title: '新型威胁隐蔽性强', desc: 'APT攻击、零日漏洞利用等新型威胁具有隐蔽性强、变种速度快的特点。' },
      { title: 'AI防御误报率高', desc: '单纯AI防御模型缺乏威胁情报上下文支撑，误报、漏报率偏高。' },
      { title: '情报与防御脱节', desc: '威胁情报与防火墙等防御设备缺乏有效联动。' }
    ],
    capabilities: [
      { title: '情报处理高效化', desc: '依托AI自动化分析能力，快速处理海量威胁情报' },
      { title: '威胁检测精准化', desc: '融合AI深度学习与威胁情报上下文，精准识别新型威胁' },
      { title: 'AI联动一体化', desc: '打通威胁情报与防御体系的联动壁垒，构建主动防御闭环' },
      { title: '运维管理智能化', desc: 'AI替代人工完成重复性运维工作，提升防御响应效率' }
    ],
    scenarios: [
      { title: '威胁情报自动化研判', desc: '依托AI算法自动处理海量威胁情报，快速筛选研判' },
      { title: '新型威胁精准检测', desc: '结合AI深度学习与威胁情报上下文，精准识别隐蔽性威胁' },
      { title: '威胁溯源与攻击预测', desc: '追溯攻击来源、攻击路径，预测潜在威胁趋势' }
    ],
    architecture: 'AI加持威胁情报解决方案采用"情报处理-威胁检测-联动响应"三层架构。底层依托AI自动化分析能力快速处理海量威胁情报，中间层融合AI深度学习与威胁情报上下文精准识别威胁，上层打通威胁情报与防御体系的联动壁垒，构建主动防御闭环。',
    faq: [
      { question: 'AI如何提升威胁检测准确率？', answer: 'AI模型结合威胁情报上下文进行深度分析，相比传统规则检测，大幅降低误报率，提升未知威胁发现能力。' },
      { question: '如何与现有安全设备联动？', answer: '提供标准化接口，可与防火墙、WAF、SOC等安全设备联动，实现情报自动下发和策略自动更新。' },
      { question: '情报更新频率如何？', answer: '支持实时情报接入，分钟级更新本地情报库，确保威胁检测的时效性。' }
    ],
    relatedProducts: ['hyper-converged-cloud', 'log-audit', 'vulnerability-scanner']
  },

  'cloud-edge-model-collaboration': {
    title: '云边大小模型协同解决方案',
    category: 'aiApplication',
    description: '云端大模型与边缘小模型协同的智能运维方案，破解运维痛点',
    heroImage: null,
    background: '随着数字化转型推进，企业运维场景呈现分布式、异构化特征，边缘设备与终端节点激增，运维数据海量集中在边缘侧。传统人工与固定规则运维模式难以适配，单纯云端大模型存在时延高、隐私风险，边缘小模型则受算力限制。瑞和云图云边大小模型协同解决方案，破解运维痛点、推动运维模式向主动预判转型。',
    challenges: [
      { title: '运维数据处理效率低', desc: '边缘运维数据海量分散，上传云端时延高、带宽占用大。' },
      { title: '大小模型协同不畅', desc: '云端与边缘模型缺乏有效协同机制，参数更新不同步。' },
      { title: '边缘算力受限', desc: '边缘设备算力参差不齐，部分设备无法承载复杂模型部署。' },
      { title: '故障研判精准度不足', desc: '边缘小模型泛化能力不足、云端大模型时延高。' }
    ],
    capabilities: [
      { title: '运维响应高效化', desc: '边缘小模型本地化实时处置故障，云端大模型承接复杂故障研判' },
      { title: '模型协同互补', desc: '建立完善云边协同机制，实现云端泛化能力下沉、边缘数据反哺' },
      { title: '模型部署灵活', desc: '为不同算力边缘设备定制轻量化模型，按需部署' },
      { title: '故障研判精准', desc: '融合边缘小模型精准识别与云端大模型强泛化能力' }
    ],
    scenarios: [
      { title: '边缘设备实时运维处置', desc: '由边缘小模型本地化处理运维数据，实现故障实时识别' },
      { title: '复杂运维故障深度研判', desc: '将关键数据上传至云端大模型，完成深度分析与解决方案生成' },
      { title: '模型协同迭代与统一部署', desc: '云端大模型整合全量运维数据完成训练优化，下发至边缘节点' }
    ],
    architecture: '云边大小模型协同解决方案采用"云端大模型-边缘小模型"双层架构。边缘小模型承担本地实时处置任务，时延控制在毫秒级；云端大模型负责复杂故障研判、模型训练优化。通过云边协同机制实现模型参数同步和知识传递。',
    faq: [
      { question: '大小模型如何分工？', answer: '边缘小模型处理常见、重复性运维任务，实现快速响应；云端大模型处理复杂、新型故障，提供深度分析。' },
      { question: '边缘设备算力不足怎么办？', answer: '为不同算力边缘设备定制轻量化模型，通过模型量化、剪枝技术适配边缘硬件。' },
      { question: '模型如何持续优化？', answer: '边缘数据脱敏后上传云端，用于模型训练和优化，优化后的模型自动下发至边缘节点，实现持续迭代。' }
    ],
    relatedProducts: ['ai-computing', 'edge-cloud-platform', 'hyper-converged-cloud']
  },

  'edge-cv-security': {
    title: '边缘CV应用解决方案',
    category: 'aiApplication',
    description: '边缘智能视觉与安全能力融合应用方案，推动安防向主动预警升级',
    heroImage: null,
    background: 'CV技术在安防、工业巡检等安全领域广泛应用，边缘场景成为核心落地载体。传统纯边缘小模型或纯云端大模型部署存在明显短板，无法适配多元化需求。瑞和云图边缘CV应用解决方案，基于云边端大小模型协同方案，云端大模型负责全局决策、模型训练优化，边缘小模型承担本地实时推理响应，推动边缘CV安全应用向主动预警、智能防控升级。',
    challenges: [
      { title: '实时性与识别精度矛盾', desc: '边缘CV安全应用需毫秒级响应，但边缘算力有限，小模型精度不足。' },
      { title: '边缘算力资源受限', desc: '边缘终端多为低功耗低成本设备，无法部署复杂CV大模型。' },
      { title: '数据隐私与合规风险', desc: '采集的图像、视频多为敏感数据，全量上传云端易泄露。' },
      { title: '多场景适配效率低', desc: '应用场景多样，单一模型无法适配，迭代效率低。' }
    ],
    capabilities: [
      { title: '协同调度', desc: '大小模型智能分流协同，兼顾实时性与精准性' },
      { title: '轻量化优化', desc: '边缘小模型经量化、剪枝优化，适配低功耗设备' },
      { title: '本地处理', desc: '敏感数据本地处理，仅上传推理结果或关键特征' },
      { title: '自适应迭代', desc: '云端大模型为不同场景定制专属小模型，自动更新' }
    ],
    scenarios: [
      { title: '工业安全巡检', desc: '适配工厂、矿山等工业场景，聚焦设备缺陷、违规操作防控' },
      { title: '智慧园区安防', desc: '覆盖园区重点部位，防控人员入侵、物品遗留等异常' },
      { title: '交通安防管控', desc: '边缘小模型实时识别违章、事故等异常并推送预警' }
    ],
    architecture: '边缘CV应用解决方案采用"云端大模型训练-边缘小模型推理"协同架构。云端大模型负责全局决策和模型训练优化，为不同场景定制专属小模型；边缘小模型承担本地实时推理响应，通过量化、剪枝优化适配低功耗设备。',
    faq: [
      { question: '如何平衡实时性与精度？', answer: '大小模型智能分流协同，常规场景由边缘小模型快速响应，复杂场景交由云端大模型精准识别。' },
      { question: '敏感数据如何处理？', answer: '图像、视频等敏感数据本地处理，仅上传推理结果或关键特征，保障数据隐私和合规要求。' },
      { question: '如何适配多场景需求？', answer: '云端大模型为不同场景定制专属小模型，自动更新下发，实现多场景自适应迭代。' }
    ],
    relatedProducts: ['ai-computing', 'edge-cloud-platform', 'hyper-converged-cloud']
  },

  'vehicle-ai-offense-defense-range': {
    title: '车联网AI攻防靶场解决方案',
    category: 'aiApplication',
    description: '面向车联网场景的AI攻防训练与验证方案，满足欧盟R155/R156法规要求',
    heroImage: null,
    background: '车联网通过车载TBox、IVI、网关和网络架构实现车辆与云端的数据交互，主要功能包括实时监控车辆状态、远程控制、智能导航与出行服务、车机互联以及V2X车路协同。瑞和云图车联网AI攻防靶场解决方案，为车企提供实战型AI攻防靶场，实现终端、业务安全测试、攻防演练及合规检测。',
    challenges: [
      { title: '仿真场景贴合度低', desc: '传统靶场仿真环境单一，无法精准复现真实交互场景。' },
      { title: '威胁检测能力薄弱', desc: '车联网攻击手段日趋智能化、隐蔽化，传统检测难以识别。' },
      { title: '资源调度僵化', desc: '攻防测试规模动态变化，传统靶场资源分配固定。' },
      { title: '管控运维复杂', desc: '靶场涉及多环节，缺乏统一的可视化管控平台。' }
    ],
    capabilities: [
      { title: '底座支撑稳固', desc: '提供弹性计算、虚拟网络等基础资源，支撑多场景高并发任务' },
      { title: '仿真场景全面', desc: '搭建虚实结合的高保真仿真环境，覆盖车载核心业务' },
      { title: '威胁检测全面', desc: '实现流量预处理、日志存储与全链路威胁识别' },
      { title: 'AI深度赋能', desc: 'AI技术深度融入攻防全流程，提升威胁识别精度与效率' }
    ],
    scenarios: [
      { title: '车载终端安全测试', desc: '针对TBOX、车机、车载传感器等终端设备开展安全测试' },
      { title: '车载业务安全验证', desc: '覆盖OTA升级、车载APP、VSOC等核心车载业务' },
      { title: '攻防演练与人才培养', desc: '为车企、安全企业提供实战化攻防演练环境' }
    ],
    architecture: '车联网AI攻防靶场解决方案采用"弹性底座-仿真环境-威胁检测-AI赋能"四层架构。底层提供弹性计算、虚拟网络等基础资源，仿真层搭建虚实结合的高保真环境，威胁检测层实现流量预处理和全链路威胁识别，AI层深度融入攻防全流程。',
    faq: [
      { question: '如何满足欧盟R155/R156法规要求？', answer: '方案提供完整的合规检测能力和报告生成，覆盖法规要求的安全测试项，帮助车企满足出口合规要求。' },
      { question: '仿真环境的真实度如何？', answer: '搭建虚实结合的高保真仿真环境，覆盖TBOX、IVI、网关等核心组件，精准复现真实交互场景。' },
      { question: 'AI如何赋能攻防测试？', answer: 'AI技术深度融入攻击模拟、威胁检测、漏洞挖掘等环节，提升测试效率和威胁识别精度。' }
    ],
    relatedProducts: ['ai-computing', 'hyper-converged-cloud', 'vulnerability-scanner']
  }
}

// 根据 slug 获取解决方案数据
export function getSolutionBySlug(slug) {
  return solutionsData[slug] || null
}

// 获取解决方案所属分类
export function getSolutionCategory(slug) {
  const solution = solutionsData[slug]
  if (!solution) return null
  return solutionCategories[solution.category] || null
}

// 获取相关解决方案
export function getRelatedSolutions(slug, limit = 3) {
  const solution = solutionsData[slug]
  if (!solution) return []
  
  const category = solutionCategories[solution.category]
  if (!category) return []
  
  return category.solutions
    .filter(s => s !== slug)
    .slice(0, limit)
    .map(s => solutionsData[s])
    .filter(Boolean)
}
